import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import promise from 'redux-promise';
import 'core-js/fn/string/starts-with';

import reducers from './reducers';
import './stylesheets/dev/styles.css';
import Header from './components/Header';
import {
  LINK_ENTREGA, LINK_FDV, LINK_LOGISTICA_ASIG, LINK_LOGISTICA_ETIQ, LINK_LOGISTICA_INVE, LINK_ENTREGA_LOGIS,
  LINK_INMATRICULACION_CORREO, LINK_INMATRICULACION_CARGA_TITULO, LINK_BANDEJA_ACT
} from './constants';
import IndexFichaVenta from './containers/IndexFichaVenta';
import ProformaFichaVenta from './pages/ProformaFichaVenta';
import DetalleFichaVenta from './pages/DetalleFichaVenta';
import MantCapacidades from './pages/MantCapacidades';
import MantLugarDespacho from './pages/MantLugarDespacho';
import MantLugarEntrega from './pages/MantLugarEntrega';
import MantSkuVehiculo from './pages/MantSkuVehiculo' //<88181>
import MantFilialEntrega from './pages/MantFilialEntrega';
import MantDiasTraslado from './pages/MantDiasTraslado';
import MantAreadeVenta from './pages/MantAreadeVenta';
import MantUbicacionPedido from './pages/MantUbicacionPedido';
import FichaEntrega from './containers/FichaEntrega';
import InmatriculacionCorreo from './containers/InmatriculacionCorreo';
import InmatriculacionCargaTitulo from './containers/InmatriculacionCargaTitulo';
import FichaAsignaciones from './containers/FichaAsignaciones';
import FichaEtiquetado from './containers/FichaEtiquetado';
import FichaInventario from './containers/FichaInventario';
import FichaEntregasLogistica from './containers/FichaEntregasLogistica';
import CalendarContainer from './containers/CalendarContainer';
import MantMaestros from './pages/MantMaestros';
import Token from './containers/PruebaToken';
import Login from './containers/Login';
import registerServiceWorker from './registerServiceWorker';
import unAuthorized from './pages/Error/unAuthorized';
import IndexBandejaActividades from './containers/IndexBandejaActividades';

const createStoreWithMiddleware = applyMiddleware(promise)(createStore);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <BrowserRouter>
      <div className='sidnew'>
        <Header />
        <Switch>
          <Route path={LINK_LOGISTICA_ASIG} component={FichaAsignaciones} />
          <Route path={LINK_LOGISTICA_ETIQ} component={FichaEtiquetado} />
          <Route path={LINK_LOGISTICA_INVE} component={FichaInventario} />
          <Route path={LINK_ENTREGA} component={FichaEntrega} />
          <Route path={LINK_INMATRICULACION_CORREO} component={InmatriculacionCorreo} />
          <Route path={LINK_INMATRICULACION_CARGA_TITULO} component={InmatriculacionCargaTitulo} />
          <Route path={LINK_ENTREGA_LOGIS} component={FichaEntregasLogistica} />
          <Route {...ProformaFichaVenta.route} exact />
          <Route {...DetalleFichaVenta.route} exact />
          <Route {...MantLugarDespacho.route} />
          <Route {...MantLugarEntrega.route} />
          <Route {...MantSkuVehiculo.route.editar} />  
          <Route {...MantSkuVehiculo.route.index} />
          <Route {...MantFilialEntrega.route} />
          <Route {...MantDiasTraslado.route} />
          <Route {...MantUbicacionPedido.route} />
          <Route {...MantCapacidades.route} />
          <Route {...MantAreadeVenta.route}/>
          <Route {...MantMaestros.route.nuevo} />
          <Route {...MantMaestros.route.editar} />
          <Route {...MantMaestros.route.index} />
          <Route {...MantMaestros.route.index2} />
          <Route path={`${LINK_FDV}/`} component={IndexFichaVenta} />
          <Route path={`${LINK_BANDEJA_ACT}/`} component={IndexBandejaActividades} />
          <Route path='/calendar' component={CalendarContainer} />
          <Route path='/token' component={Token} />
          <Route path='/login' component={Login} />
          <Route path='/401' component={unAuthorized} />
        </Switch>
      </div>
    </BrowserRouter>
  </Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js